/**
 * Fetches flow data from API
 * @param {string} flexSlug 
 * @param {object} apiStore 
 * @returns {object}
 */
export const fetchFlexData = async (flexSlug, apiStore) => {
    if (!flexSlug) {
        throw new Error("No flexSlug given");
    }

    const endpoint = `/flex_routing/${flexSlug}/`;
    try{
        const {status, response} = await apiStore.fetch(endpoint)
        if (status !== 200 || !response) {
            if (status !== 404) {
                console.error('Failed to fetch flex data', {endpoint, status, response});
            }
            return null;
        }

        return response;
    }catch(error){
        console.error('Failed to fetch flex data', {endpoint, error});
        return null;
    }
}
